import React, { useState, useEffect } from 'react';
import DTMF from './Dtmf';
import { SvgIcon } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import {
    CallEnd,
    Call,
    Pause,
    Dialpad,
    Loop,
    PlayArrow,
} from '@mui/icons-material';
import { searchContacts } from '../services/webRTCService';
import styled from '@emotion/styled';

const CallDesign = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    padding-top: 2rem;
    z-index: 103;
    transition: all 500ms ease;
    span {
        font-family: 'Roboto', sans-serif;
        color: #fafafa;
    }
    .callTimer {
        font-size: ${(props) =>
            props.showDtmf && props.newSession ? '14px' : '20px'};
        transition: all 500ms ease;
        /* font-size: 16px; */
        line-height: 24px;
    }
    .user-icon {
        transition: all 500ms ease;
        font-size: ${(props) =>
            props.showDtmf && props.newSession ? '40px' : '100px'};
        /* transform:  */
    }
    .callName {
        /* font-size: 24px; */
        font-size: ${(props) =>
            props.showDtmf && props.newSession ? '16px' : '24px'};
        font-weight: 900;
        line-height: 22px;
        margin-top: ${(props) =>
            props.showDtmf && props.newSession ? '-0.5rem' : '0.5rem'};
        transition: font-size 500ms ease;
    }
    .callNumber {
        /* font-size: 18px; */
        font-size: ${(props) =>
            props.showDtmf && props.newSession ? '14px' : '18px'};
        font-weight: 400;
        line-height: 22px;
        margin-top: ${(props) =>
            props.showDtmf && props.newSession ? '0.5rem' : '1rem'};
        transition: font-size 500ms ease;
    }
`;

const ControlButtons = styled.div`
    position: absolute;
    bottom: 1.5rem;
    display: flex;
    flex-direction: row;
    gap: 1rem;
    margin-top: 20px;

    .callButton {
        border: none;
        cursor: pointer;
        width: 70px;
        height: 70px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        svg {
            color: white;
            width: 24px;
            height: 24px;
        }
    }
`;

const DTMFContainer = styled.div`
    position: absolute;
    bottom: ${(props) => (props.show ? '95px' : '-50%')};
    left: 50%;
    transform: translateX(-50%);
    opacity: ${(props) => (props.show ? '1' : '0')};
    transition: all 500ms ease;
    z-index: 104;
`;

const OnHoldUser = styled.div`
    width: 100%;
    margin-top: 0.5rem;
    padding: 0.5rem 1rem;
    background: linear-gradient(
        155deg,
        rgba(43, 14, 69, 1) 0%,
        rgba(143, 79, 86, 1) 100%
    );
    height: 75px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    bottom: ${(props) =>
        props.showDtmf && props.newSession ? '440px' : '135px'};
    transition: bottom 500ms ease;
    .content {
        display: flex;
        flex-direction: row;
        gap: 1rem;
        align-items: center;
        justify-content: center;
        .user-logo {
            display: flex;
            align-items: center;
        }
        .user-info {
            display: flex;
            flex-direction: column;
            gap: 0.25rem;
            color: #ccc;
            h3 {
                font-size: 14px;
                margin: 0;
            }
            p {
                font-size: 12px;
                margin: 0;
            }
            span {
                font-size: 10px;
            }
        }
    }
    button {
        border: none;
        background: transparent;
        display: flex;
        flex-direction: column;
        gap: 0.125rem;
        color: #ccc;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        svg {
            transition: transform 500ms ease;
        }
        &:hover {
            svg {
                transform: rotate(180deg);
                color: #d3d3d3;
            }
        }
    }
`;

const CallWaiting = ({
    newSession,
    currentSession,
    auth,
    firstCallInfo,
    setFirstCallInfo,
    onReject,
    onRejectCurrentCall,
    onAnswer,
    onHold,
    onAnswerAndHoldWaiting,
    setCallWaiting,
    clearWatingSession,
    toggleHold,
    getCurrentSessionHoldStatus,
    selectedBnum,
}) => {
    const [incomingCallInfo, setIncomingCallInfo] = useState(null);
    const [currentUserInfo, setCurrentUserInfo] = useState(null);
    const [callStatus, setCallStatus] = useState('');
    const [callTimer, setCallTimer] = useState(0);
    const [dtmfKeypadState, setDtmfKeypadState] = useState({
        currentCall: false,
        incomingCall: false,
    });
    const [dtmfInput, setDtmfInput] = useState({
        currentCall: '',
        incomingCall: '',
    });
    const [showOptions, setShowOptions] = useState(false);
    const [watingUserInfo, setWaitingUserInfo] = useState(null);
    const [isCurrentCallOnHold, setIsCurrentCallOnHold] = useState(false);

    useEffect(() => {
        console.log('CallWaiting component mounted');

        const handleFailedNewSession = (e) => {
            console.error('Call failed:', e.cause);
            clearWatingSession();
            setCallWaiting(false);
        };

        const handleEndedNewSession = () => {
            const uri = newSession.remote_identity.uri.toString();
            const number = uri.split('@')[0].replace('sip:', '');
            console.log('Call ended by the remote party.', number);
            console.log('Step2');
            clearWatingSession();
            // if(!currentSession){
            //     // setCallWaiting(false);
            //     onRejectCurrentCall(null, currentSession);
            // }
        };

        const handleEndedCurrentSession = () => {
            console.log(
                'Hosein Hosein',
                newSession?.remote_identity.uri
                    .toString()
                    .split('@')[0]
                    .replace('sip:', '')
            );
            console.log('xxxx-1');
            onRejectCurrentCall(null, newSession);
        };

        const handleHoldCurrentSession = () => {
            console.log('Current call put on hold');
            setIsCurrentCallOnHold(true);
        };

        const handleUnholdCurrentSession = () => {
            console.log('Current call taken off hold');
            setIsCurrentCallOnHold(false);
        };

        // Listen for the 'failed' event to detect when the call fails
        newSession?.on('failed', handleFailedNewSession);
        // Listen for the 'ended' event to detect when the call ends
        newSession?.on('ended', handleEndedNewSession);

        if (currentSession) {
            currentSession.on('ended', handleEndedCurrentSession);
            currentSession.on('hold', handleHoldCurrentSession);
            currentSession.on('unhold', handleUnholdCurrentSession);
        }

        return () => {
            console.log('CallWaiting cleanup - removing event listeners');
            if (newSession) {
                newSession.off('failed', handleFailedNewSession);
                newSession.off('ended', handleEndedNewSession);
            }
            if (currentSession) {
                currentSession.off('ended', handleEndedCurrentSession);
                currentSession.off('hold', handleHoldCurrentSession);
                currentSession.off('unhold', handleUnholdCurrentSession);
            }
        };
    }, [currentSession, newSession]);

    useEffect(() => {
        const fetchContactName = async (number) => {
            const name = await getContactName(number);
            setIncomingCallInfo({ number, name });
        };
        console.log('New session available:', newSession, incomingCallInfo);
        if (newSession && incomingCallInfo === null) {
            const uri = newSession.remote_identity.uri.toString();
            const number = uri.split('@')[0].replace('sip:', '');
            console.log('Call waiting from:', number);
            fetchContactName(number);
        }
    }, [newSession, currentSession, auth]);

    useEffect(() => {
        // Handle case when currentSession is null
        if (!currentSession || !currentSession.remote_identity) {
            console.log('No current session or remote identity available');
            // Reset user info when no current session
            setCurrentUserInfo(null);
            setWaitingUserInfo(incomingCallInfo);
            return;
        }

        try {
            const uri = currentSession.remote_identity.uri.toString();
            const number = uri.split('@')[0].replace('sip:', '');
            if (number === firstCallInfo?.number) {
                setCurrentUserInfo(firstCallInfo);
                setWaitingUserInfo(incomingCallInfo);
                console.log('up', incomingCallInfo);
            } else if (number === incomingCallInfo?.number) {
                setCurrentUserInfo(incomingCallInfo);
                setWaitingUserInfo(firstCallInfo);
                console.log('down', incomingCallInfo);
            }
        } catch (error) {
            console.error('Error processing current session:', error);
            setCurrentUserInfo(null);
            setWaitingUserInfo(incomingCallInfo);
        }
    }, [currentSession, incomingCallInfo, firstCallInfo]);

    useEffect(() => {
        console.log(
            'currentSession is:',
            currentSession
                ? currentSession.remote_identity.uri
                      .toString()
                      .split('@')[0]
                      .replace('sip:', '')
                : 'No session'
        );
        console.log(
            'newSession(waiting session) is:',
            newSession
                ? newSession.remote_identity.uri
                      .toString()
                      .split('@')[0]
                      .replace('sip:', '')
                : 'No session'
        );
        if (!newSession) {
            if (
                currentSession?.remote_identity.uri
                    .toString()
                    .split('@')[0]
                    .replace('sip:', '') === incomingCallInfo?.number
            ) {
                console.log(
                    'Change first call info and make incoming call info null'
                );
                setFirstCallInfo(incomingCallInfo);
            }
            setIncomingCallInfo(null);
        }
        if (!currentSession) {
            setFirstCallInfo(null);
        }
    }, [newSession, currentSession]);

    useEffect(() => {
        let interval;
        if (callStatus === 'active') {
            interval = setInterval(() => {
                setCallTimer((prevTimer) => prevTimer + 1);
            }, 1000);
        } else {
            setCallTimer(0);
        }

        return () => {
            if (interval) {
                clearInterval(interval);
            }
        };
    }, [callStatus]);

    const handleName = (contact) => {
        if (
            contact.firstNameLowerCase == null &&
            contact.lastNameLowerCase == null
        )
            return 'No name';
        if (
            contact.firstNameLowerCase == null &&
            contact.lastNameLowerCase != null
        )
            return `${contact.lastNameLowerCase.charAt(0).toUpperCase() + contact.lastNameLowerCase.slice(1)}`;
        if (
            contact.firstNameLowerCase != null &&
            contact.lastNameLowerCase == null
        )
            return `${contact.firstNameLowerCase.charAt(0).toUpperCase() + contact.firstNameLowerCase.slice(1)}`;
        return `${contact.firstNameLowerCase.charAt(0).toUpperCase() + contact.firstNameLowerCase.slice(1)} ${contact.lastNameLowerCase.charAt(0).toUpperCase() + contact.lastNameLowerCase.slice(1)}`;
    };

    const getContactName = async (number) => {
        try {
            const data = await searchContacts(
                auth,
                'search',
                number,
                100,
                false,
                selectedBnum?.country
            );
            console.log('Contact data:', data);
            const contactName =
                data.data.contacts.length === 1
                    ? handleName(data.data.contacts[0])
                    : '';
            return contactName;
        } catch (error) {
            console.error('Error fetching contact information:', error);
            return '';
        }
    };

    const handleToggleHold = () => {
        if (toggleHold && currentSession) {
            toggleHold(currentSession);
        }
    };

    return (
        <>
            {callStatus === 'active' &&
            (!newSession || (newSession && newSession.isEstablished())) ? (
                <CallDesign
                    showDtmf={
                        currentUserInfo?.number === firstCallInfo?.number
                            ? dtmfKeypadState.currentCall
                            : dtmfKeypadState.incomingCall
                    }
                    newSession={newSession}
                >
                    {currentUserInfo?.name ? (
                        <>
                            <span className="callName">
                                {currentUserInfo?.name}{' '}
                                {getCurrentSessionHoldStatus() &&
                                    (currentUserInfo?.number ===
                                    firstCallInfo?.number
                                        ? dtmfKeypadState.currentCall
                                        : dtmfKeypadState.incomingCall) && (
                                        <span
                                            style={{
                                                color: '#f39c12',
                                                fontSize: '14px',
                                            }}
                                        >
                                            (On Hold)
                                        </span>
                                    )}
                            </span>
                            <span className="callNumber">
                                {currentUserInfo?.number}
                            </span>
                        </>
                    ) : (
                        <span className="callName">
                            {currentUserInfo?.number}{' '}
                            {getCurrentSessionHoldStatus() &&
                                (currentUserInfo?.number ===
                                firstCallInfo?.number
                                    ? dtmfKeypadState.currentCall
                                    : dtmfKeypadState.incomingCall) && (
                                    <span
                                        style={{
                                            color: '#f39c12',
                                            fontSize: '14px',
                                        }}
                                    >
                                        (On Hold)
                                    </span>
                                )}
                        </span>
                    )}
                    <SvgIcon
                        className="user-icon"
                        sx={{ color: '#fafafa', fontSize: 100, margin: '0' }}
                    >
                        <PersonIcon />
                    </SvgIcon>
                    <span className="callTimer">
                        {`${Math.floor(callTimer / 60)
                            .toString()
                            .padStart(
                                2,
                                '0'
                            )}:${(callTimer % 60).toString().padStart(2, '0')}`}
                    </span>
                    {getCurrentSessionHoldStatus() &&
                        !(currentUserInfo?.number === firstCallInfo?.number
                            ? dtmfKeypadState.currentCall
                            : dtmfKeypadState.incomingCall) && (
                            <span
                                style={{
                                    color: '#f39c12',
                                    fontSize: '16px',
                                    marginTop: '10px',
                                }}
                            >
                                (On Hold)
                            </span>
                        )}
                    {newSession ? (
                        <OnHoldUser
                            showDtmf={
                                currentUserInfo?.number ===
                                firstCallInfo?.number
                                    ? dtmfKeypadState.currentCall
                                    : dtmfKeypadState.incomingCall
                            }
                            newSession={newSession}
                        >
                            <div className="content">
                                <div className="user-logo">
                                    <PersonIcon
                                        sx={{
                                            color: '#ccc',
                                            fontSize: 60,
                                            backgroundColor:
                                                'rgba(255, 255, 255, 0.1)',
                                            borderRadius: '50%',
                                            padding: '6px',
                                        }}
                                    />
                                </div>
                                <div className="user-info">
                                    <h3>
                                        {watingUserInfo?.name
                                            ? ` ${watingUserInfo.name}`
                                            : 'No name'}
                                    </h3>
                                    <p>{watingUserInfo?.number}</p>
                                    <span>On hold</span>
                                </div>
                            </div>
                            <button
                                onClick={() => {
                                    setCallStatus('active');
                                    onHold(
                                        currentSession,
                                        newSession,
                                        incomingCallInfo
                                    );
                                }}
                            >
                                <>
                                    <Loop />
                                    <span>Swap</span>
                                </>
                            </button>
                        </OnHoldUser>
                    ) : (
                        ''
                    )}
                    <DTMFContainer
                        show={
                            currentUserInfo?.number === firstCallInfo?.number
                                ? dtmfKeypadState.currentCall
                                : dtmfKeypadState.incomingCall
                        }
                    >
                        <DTMF
                            callStatus={callStatus}
                            showDtmfKeypad={
                                currentUserInfo?.number ===
                                firstCallInfo?.number
                                    ? dtmfKeypadState.currentCall
                                    : dtmfKeypadState.incomingCall
                            }
                            session={currentSession}
                            dtmfInput={
                                currentUserInfo?.number ===
                                firstCallInfo?.number
                                    ? dtmfInput.currentCall
                                    : dtmfInput.incomingCall
                            }
                            setDtmfInput={(value) => {
                                setDtmfInput((prev) => ({
                                    ...prev,
                                    [currentUserInfo?.number ===
                                    firstCallInfo?.number
                                        ? 'currentCall'
                                        : 'incomingCall']: value,
                                }));
                            }}
                        />
                    </DTMFContainer>
                    <audio id="localAudio" autoPlay></audio>
                    <ControlButtons>
                        <button
                            onClick={() => {
                                // setCallStatus("");
                                onRejectCurrentCall(currentSession, newSession);
                            }}
                            className="callButton"
                            style={{
                                backgroundColor: '#e74c3c',
                            }}
                        >
                            <CallEnd />
                        </button>
                        <button
                            onClick={handleToggleHold}
                            className="callButton"
                            style={{
                                // backgroundColor: isCurrentCallOnHold ? '#f39c12' : '#444',
                                backgroundColor: getCurrentSessionHoldStatus()
                                    ? '#f39c12'
                                    : '#444',
                                opacity: callStatus === 'active' ? 1 : 0.5,
                            }}
                        >
                            <SvgIcon>
                                {getCurrentSessionHoldStatus() ? (
                                    <PlayArrow
                                        sx={{ color: 'white', fontSize: 24 }}
                                    />
                                ) : (
                                    <Pause
                                        sx={{ color: 'white', fontSize: 24 }}
                                    />
                                )}
                            </SvgIcon>
                        </button>
                        {/* {newSession ? (
                            <Tooltip
                                title={`Switch to on-hold call: ${watingUserInfo?.name ? ` ${watingUserInfo.name}` : ''} ${watingUserInfo?.number}`}
                                placement="top"
                                arrow
                            >
                                <button
                                    onClick={() => {
                                        setCallStatus("active");
                                        onHold(currentSession, newSession, incomingCallInfo)
                                    }}
                                    style={{
                                        backgroundColor: '#f39c12',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '50%',
                                        width: '60px',
                                        height: '60px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        cursor: 'pointer'
                                    }}
                                >
                                    <SwapHoriz />
                                </button>
                            </Tooltip>
                        ) : ""} */}
                        {(
                            currentUserInfo?.number === firstCallInfo?.number
                                ? dtmfKeypadState.currentCall
                                : dtmfKeypadState.incomingCall
                        ) ? (
                            <p
                                style={{
                                    color: '#fff',
                                    fontSize: '12px',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                                onClick={() =>
                                    setDtmfKeypadState((prev) => ({
                                        ...prev,
                                        [currentUserInfo?.number ===
                                        firstCallInfo?.number
                                            ? 'currentCall'
                                            : 'incomingCall']: false,
                                    }))
                                }
                            >
                                Hide Keypad
                            </p>
                        ) : (
                            <button
                                onClick={() =>
                                    setDtmfKeypadState((prev) => ({
                                        ...prev,
                                        [currentUserInfo?.number ===
                                        firstCallInfo?.number
                                            ? 'currentCall'
                                            : 'incomingCall']: true,
                                    }))
                                }
                                className="callButton"
                                style={{
                                    backgroundColor: '#444',
                                }}
                            >
                                <SvgIcon>
                                    <Dialpad
                                        sx={{ color: 'white', fontSize: 24 }}
                                    />
                                </SvgIcon>
                            </button>
                        )}
                    </ControlButtons>
                </CallDesign>
            ) : (
                <>
                    {currentSession && newSession && showOptions && (
                        <div
                            style={{
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                backgroundColor: 'rgba(0, 0, 0, 0.8)',
                                zIndex: 105, // Higher than other elements
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                padding: '20px',
                            }}
                        >
                            <div
                                style={{
                                    backgroundColor: '#fff',
                                    borderRadius: '12px',
                                    padding: '20px',
                                    width: '90%',
                                    maxWidth: '320px',
                                    textAlign: 'center',
                                }}
                            >
                                <h3
                                    style={{
                                        margin: '0 0 20px',
                                        fontSize: '18px',
                                    }}
                                >
                                    What Would You Like To Do to the Current
                                    Call?
                                </h3>

                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '10px',
                                    }}
                                >
                                    <button
                                        onClick={() => {
                                            setShowOptions(false);
                                            setCallStatus('active');
                                            onAnswer(
                                                currentSession,
                                                newSession
                                            );
                                        }}
                                        style={{
                                            backgroundColor: '#e74c3c',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '8px',
                                            padding: '12px',
                                            fontSize: '16px',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        End Current Call
                                    </button>

                                    <button
                                        onClick={() => {
                                            setShowOptions(false);
                                            setCallStatus('active');
                                            onHold(currentSession, newSession);
                                        }}
                                        style={{
                                            backgroundColor: '#f39c12',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '8px',
                                            padding: '12px',
                                            fontSize: '16px',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        Hold Current Call
                                    </button>

                                    <button
                                        onClick={() => {
                                            setShowOptions(false);
                                        }}
                                        style={{
                                            backgroundColor: '#95a5a6',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '8px',
                                            padding: '12px',
                                            fontSize: '16px',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    <div
                        style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(0, 0, 0, 0.8)',
                            zIndex: 104, // Higher than current call
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '20px',
                        }}
                    >
                        <div
                            style={{
                                backgroundColor: '#fff',
                                borderRadius: '12px',
                                padding: '20px',
                                width: '90%',
                                maxWidth: '320px',
                                textAlign: 'center',
                            }}
                        >
                            <audio src="/ringtone.mp3" autoPlay loop></audio>
                            <h3
                                style={{ margin: '0 0 10px', fontSize: '20px' }}
                            >
                                Incoming Call
                            </h3>
                            <p
                                style={{
                                    fontSize: '14px',
                                    color: '#666',
                                    margin: '0 0 15px',
                                }}
                            >
                                You're currently on another call
                            </p>
                            <SvgIcon
                                sx={{
                                    color: '#475467',
                                    fontSize: 64,
                                    margin: '10px 0',
                                }}
                            >
                                <PersonIcon />
                            </SvgIcon>
                            {incomingCallInfo?.name ? (
                                <>
                                    <p
                                        style={{
                                            fontSize: '18px',
                                            fontWeight: 'bold',
                                            margin: '10px 0',
                                        }}
                                    >
                                        {incomingCallInfo?.name}
                                    </p>
                                    <p
                                        style={{
                                            fontSize: '16px',
                                            margin: '5px 0 20px',
                                        }}
                                    >
                                        {incomingCallInfo?.number}
                                    </p>
                                </>
                            ) : (
                                <p
                                    style={{
                                        fontSize: '18px',
                                        fontWeight: 'bold',
                                        margin: '10px 0',
                                    }}
                                >
                                    {newSession
                                        ? newSession.remote_identity.uri
                                              .toString()
                                              .split('@')[0]
                                              .replace('sip:', '')
                                        : currentSession?.remote_identity.uri
                                              .toString()
                                              .split('@')[0]
                                              .replace('sip:', '')}
                                </p>
                            )}

                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-around',
                                }}
                            >
                                <button
                                    onClick={() => {
                                        if (currentSession && newSession) {
                                            // Show options instead of immediately answering
                                            setShowOptions(true);
                                        } else {
                                            setCallStatus('active');
                                            onAnswer(
                                                currentSession,
                                                newSession
                                            );
                                        }
                                    }}
                                    style={{
                                        backgroundColor: '#2ecc71',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '50%',
                                        width: '60px',
                                        height: '60px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        cursor: 'pointer',
                                    }}
                                >
                                    <Call />
                                </button>
                                {currentSession && newSession && (
                                    <button
                                        onClick={() => {
                                            setCallStatus('active');
                                            onAnswerAndHoldWaiting(newSession);
                                        }}
                                        style={{
                                            backgroundColor: '#f39c12',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '50%',
                                            width: '60px',
                                            height: '60px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        <Pause />
                                    </button>
                                )}
                                <button
                                    onClick={() => {
                                        if (newSession) {
                                            onReject(newSession);
                                        } else if (
                                            !newSession &&
                                            currentSession &&
                                            !currentSession.isEstablished()
                                        ) {
                                            onReject('currentSession');
                                        }
                                    }}
                                    style={{
                                        backgroundColor: '#e74c3c',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '50%',
                                        width: '60px',
                                        height: '60px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        cursor: 'pointer',
                                    }}
                                >
                                    <CallEnd />
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default CallWaiting;
